module.exports = __webpack_public_path__ + "static/media/AvenirNext-Italic.313f5451.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/AvenirNext-Italic.ttf
// module id = 77
// module chunks = 0